import React, { } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { Table, Tooltip, Badge, Card, Row, Col, Empty, Modal } from 'antd';
import { createUseStyles } from 'react-jss'
import {
    ExclamationCircleOutlined,
    ExclamationOutlined,
    MoreOutlined,
    SettingOutlined
} from '@ant-design/icons';

import { Action, GET, IfElse, Model, useAuth, useUserContext } from 'fennec-ui'
import Rule, { IFTrue } from '../../../common/Rule'
import { DropdownAction, FieldWrapper } from 'fennec-ui'
import ZayavlenieNaChlenstvoVFederatsii from '../../../desktop/forms/ZayavlenieNaChlenstvoVFederatsii'
import SamostoyatelnayaRegistratsiyaVikhodaIzChlenstvaVFederatsii from '../../../desktop/forms/SamostoyatelnayaRegistratsiyaVikhodaIzChlenstvaVFederatsii'
import SamostoyatelnayaRegistratsiyaTantsoraFederatsii from '../../../desktop/forms/SamostoyatelnayaRegistratsiyaTantsoraFederatsii'
import PodatZayavlenieNaOtmenuRegistratsiiTantsoraFederatsiiVEtomRegOt from '../../../desktop/forms/PodatZayavlenieNaOtmenuRegistratsiiTantsoraFederatsiiVEtomRegOt'
import SamostoyatelnayaRegistratsiyaSudiFederatsii from '../../../desktop/forms/SamostoyatelnayaRegistratsiyaSudiFederatsii'
import PodatZayavlenieNaOtmenuRegistratsiiSudiFederatsiiVEtomRegOt from '../../../desktop/forms/PodatZayavlenieNaOtmenuRegistratsiiSudiFederatsiiVEtomRegOt'
import SamostoyatelnayaRegistratsiyaPrepodavatelyaFederatsii from '../../../desktop/forms/SamostoyatelnayaRegistratsiyaPrepodavatelyaFederatsii'
import PodatZayavlenieNaOtmenuRegistratsiiPrepodavatelyaFederatsiiVEtomRegOt from '../../../desktop/forms/PodatZayavlenieNaOtmenuRegistratsiiPrepodavatelyaFederatsiiVEtomRegOt'
import SamostoyatelnayaRegistratsiyaOrganizatora from '../../../desktop/forms/SamostoyatelnayaRegistratsiyaOrganizatora'
import PodatZayavlenieNaOtmenuRegistratsiiOrganizatoraFederatsiiVEtomRegOt from '../../../desktop/forms/PodatZayavlenieNaOtmenuRegistratsiiOrganizatoraFederatsiiVEtomRegOt'
import SamostoyatelnayaRegistratsiyaShkoliFederatsii from '../../../desktop/forms/SamostoyatelnayaRegistratsiyaShkoliFederatsii'
import PodatZayavlenieNaAnnulirovanieLitsenziiShkoliFederatsii from '../../../desktop/forms/PodatZayavlenieNaAnnulirovanieLitsenziiShkoliFederatsii'
import AdminSchool from '../../../desktop/forms/AdminSchool'
import AdminOrg from '../../../desktop/forms/AdminOrg'
import SamostoyatelnayaRegistratsiyaPariFederatsii from '../../../desktop/forms/SamostoyatelnayaRegistratsiyaPariFederatsii'
import SamostoyatelnayaRegistratsiyaKollektivaFederatsii from '../../../desktop/forms/SamostoyatelnayaRegistratsiyaKollektivaFederatsii'
import PodatZayavlenieNaAnnulirovanieLitsenziiKollektivaFederatsii from '../../../desktop/forms/PodatZayavlenieNaAnnulirovanieLitsenziiKollektivaFederatsii'
import PredlozhenieRukiISerdtsa from '../../../desktop/forms/PredlozhenieRukiISerdtsa'
import PodatZayavlenieNaOtmenuRegistratsiiPariFederatsiiVEtomRegOt from '../../../desktop/forms/PodatZayavlenieNaOtmenuRegistratsiiPariFederatsiiVEtomRegOt'
import REDUX_ZasedaniyaPravleniyaFederatsii from '../../../objects/ZasedaniyaPravleniyaFederatsii/reducer'
import REDUX_Pari from '../../../objects/Pari/reducer';
import { POST, errorCatch } from 'fennec-ui'
import { AspectsRatio, DanceCollectionField, ImagesField, getChlenFederatsiiFromRoles, getKollektivFromRoles, getOrganizatorFromRoles, getParaFromRoles, getPrepodavatelFromRoles, getShkolaFromRoles, getSudyaFromRoles, getTantsorFromRoles, goTo, MDField, MDXField, VideosField } from '../../../common/Tool';
import RegistratsiyaTantsoraShkoli from '../../forms/RegistratsiyaTantsoraShkoli';
import uuid from 'react-uuid';
import PageLayout from '../../components/PageLayout';
import PeremeshchenieVDrugoeRO from '../../forms/PeremeshchenieVDrugoeRO';
import CRUDE_VseTipiPolzovatelei from '../../../objects/VseTipiPolzovatelei/crude';
import VikhodIzPari from '../../forms/VikhodIzPari';
import ExtendedProperties, { ExtendedPropertiesAction } from '../../forms/ExtendedProperties';
import MDEditor from '@uiw/react-md-editor';

var _ = require('lodash');

const useStyles = createUseStyles({
    modal: {
        '& .ant-modal-title': {
            marginRight: "25px"
        }
    },
    table: {
        marginLeft: "45px",
        '& .ant-table-tbody>tr>td': {
            borderBottom: "none"
        }
    },
    divider: {
        '&.ant-divider-horizontal.ant-divider-with-text-left': {
            fontFamily: "-apple-system, BlinkMacSystemFont, Roboto, 'Open Sans', 'Helvetica Neue', 'Noto Sans Armenian', 'Noto Sans Bengali', 'Noto Sans Cherokee', 'Noto Sans Devanagari', 'Noto Sans Ethiopic', 'Noto Sans Georgian', 'Noto Sans Hebrew', 'Noto Sans Kannada', 'Noto Sans Khmer', 'Noto Sans Lao', 'Noto Sans Osmanya', 'Noto Sans Tamil', 'Noto Sans Telugu', 'Noto Sans Thai', sans-serif",
            fontSize: "13px",
            fontWeight: "400",
            color: "rgb(0, 0, 0)",
        },
        '&.ant-divider-horizontal.ant-divider-with-text-left .ant-divider-inner-text': {
            padding: "0px",
            marginRight: "10px",
        }
    },
    block: {
        '& .buttons': {
            marginBottom: "10px"
        },
        // '& .buttons .ant-btn': {
        //     border: "none",
        //     '-webkit-box-shadow': "none",
        //     'box-shadow': "none"
        // }
    },
    actionTitle: {
        marginBottom: "5px",
        color: "#9a9a9ab5",
        fontStyle: "italic",
        fontSize: "13px"
    }
})


function BtnTantsor(props) {
    const dispatch = useDispatch();
    const auth = useAuth();
    const user = useUserContext();
    const UpdateRoles = () => {
        CRUDE_VseTipiPolzovatelei.read(auth, (data) => {
            if (data.length > 0) {
                dispatch({ type: 'ROLE', payload: data });
            }
        }, 'model', 's-id=ASC');
    }
    return (
        <DropdownAction icon={<MoreOutlined />} buttonStyle={{ border: "none" }} items={[
            ...IfElse(!props?.object?.peremeshchenieVDrugoeROID &&
                !props?.object?.dokumentOtFederatsiiDlyaRassmotreniyaNaVikhodID &&
                !props?.object?.zayavlenieOtTantsoraNaVikhodID &&
                !props?.object?.dokumentVikhodaIzFederatsiiID, [{
                    ...props,
                    modal: { width: "700px" },
                    mode: "MenuItem",
                    auth: props.auth,
                    title: "Перемещение танцора в другое отделение",
                    form: PeremeshchenieVDrugoeRO,
                    action: (v, unlock, close, properties) => {
                        POST(props.auth, `/api/peremeshchenietantsoravdrugoero`, { tantsorID: props.object.ID, ...v }, ({ data }) => {
                            UpdateRoles();
                            close();
                        }, (err) => errorCatch(err, unlock))
                    }
                },
                {
                    ...props,
                    modal: { width: "700px" },
                    mode: "MenuItem",
                    auth: props.auth,
                    callback: props.callback,
                    object: props.object,
                    title: "Отменить регистрацию танцора в РО",
                    form: PodatZayavlenieNaOtmenuRegistratsiiTantsoraFederatsiiVEtomRegOt,
                    document: "podatzayavlenienaotmenuregistratsiitantsorafederatsiivetomregot",
                },
                ExtendedPropertiesAction(auth, 'для танцора федерации',
                    {
                        tipPolzovatelyaID: 16,
                        polzovatelID: user?.ID,
                        tantsorID: props?.object?.ID
                    },
                    [
                        MDXField("Общее описание", "", "ОбщееОписание", false, false),
                        MDXField("Дополнительная информация", "", "ДополнительнаяИнформация", false, false),
                    ],
                    "MenuItem"
                ),
            ], [])
        ]} />
    )
};
function BtnSudya(props) {
    const dispatch = useDispatch();
    const auth = useAuth();
    const user = useUserContext();
    const UpdateRoles = () => {
        CRUDE_VseTipiPolzovatelei.read(auth, (data) => {
            if (data.length > 0) {
                dispatch({ type: 'ROLE', payload: data });
            }
        }, 'model', 's-id=ASC');
    }
    return (
        <DropdownAction icon={<MoreOutlined />} buttonStyle={{ border: "none" }} items={[
            ...IfElse(!props?.object?.peremeshchenieVDrugoeROID &&
                !props?.object?.dokumentOtFederatsiiDlyaRassmotreniyaNaVikhodID &&
                !props?.object?.zayavlenieOtSudiNaVikhodID &&
                !props?.object?.dokumentVikhodaID, [{
                    ...props,
                    modal: { width: "700px" },
                    mode: "MenuItem",
                    auth: props.auth,
                    title: "Перемещение судьи в другое отделение",
                    form: PeremeshchenieVDrugoeRO,
                    action: (v, unlock, close, properties) => {
                        POST(props.auth, `/api/peremeshcheniesudivdrugoero`, { sudyaID: props.object.ID, ...v }, ({ data }) => {
                            UpdateRoles();
                            close();
                        }, (err) => errorCatch(err, unlock))
                    }
                },
                {
                    ...props,
                    modal: { width: "700px" },
                    mode: "MenuItem",
                    auth: props.auth,
                    callback: props.callback,
                    object: props.object,
                    title: "Отменить регистрацию судьи в РО",
                    form: PodatZayavlenieNaOtmenuRegistratsiiSudiFederatsiiVEtomRegOt,
                    document: "podatzayavlenienaotmenuregistratsiisudifederatsiivetomregot",
                },
                ExtendedPropertiesAction(auth, 'для судьи федерации',
                    {
                        tipPolzovatelyaID: 22,
                        polzovatelID: user?.ID,
                        sudyaID: props?.object?.ID
                    },
                    [
                        MDXField("Общее описание", "", "ОбщееОписание", false, false),
                        MDXField("Дополнительная информация", "", "ДополнительнаяИнформация", false, false),
                    ],
                    "MenuItem"
                )
            ], [])
        ]} />
    )
};
function BtnPrepodavatel(props) {
    const dispatch = useDispatch();
    const auth = useAuth();
    const user = useUserContext();
    const UpdateRoles = () => {
        CRUDE_VseTipiPolzovatelei.read(auth, (data) => {
            if (data.length > 0) {
                dispatch({ type: 'ROLE', payload: data });
            }
        }, 'model', 's-id=ASC');
    }
    return (
        <DropdownAction icon={<MoreOutlined />} buttonStyle={{ border: "none" }} items={[
            ...IfElse(!props?.object?.peremeshchenieVDrugoeROID &&
                !props?.object?.dokumentOtFederatsiiDlyaRassmotreniyaNaVikhodID &&
                !props?.object?.zayavlenieOtPrepodavatelyaNaVikhodID &&
                !props?.object?.dokumentVikhodaID, [{
                    ...props,
                    modal: { width: "700px" },
                    mode: "MenuItem",
                    auth: props.auth,
                    title: "Перемещение преподавателя в другое отделение",
                    form: PeremeshchenieVDrugoeRO,
                    action: (v, unlock, close, properties) => {
                        POST(props.auth, `/api/peremeshchenieprepodavatelyavdrugoero`, { prepodavatelID: props.object.ID, ...v }, ({ data }) => {
                            UpdateRoles();
                            close();
                        }, (err) => errorCatch(err, unlock))
                    }
                },
                {
                    ...props,
                    modal: { width: "700px" },
                    mode: "MenuItem",
                    auth: props.auth,
                    callback: props.callback,
                    object: props.object,
                    title: "Отменить регистрацию преподавателя в РО",
                    form: PodatZayavlenieNaOtmenuRegistratsiiPrepodavatelyaFederatsiiVEtomRegOt,
                    document: "podatzayavlenienaotmenuregistratsiiprepodavatelyafederatsiivetomregot",
                },
                ExtendedPropertiesAction(auth, 'для преподавателя федерации',
                    {
                        tipPolzovatelyaID: 21,
                        polzovatelID: user?.ID,
                        prepodavatelID: props?.object?.ID
                    },
                    [
                        MDXField("Общее описание", "", "ОбщееОписание", false, false),
                        MDXField("Дополнительная информация", "", "ДополнительнаяИнформация", false, false),
                    ],
                    "MenuItem"
                )
            ], [])
        ]} />
    )
};
function BtnOrganizator(props) {
    const dispatch = useDispatch();
    const auth = useAuth();
    const user = useUserContext();
    const UpdateRoles = () => {
        CRUDE_VseTipiPolzovatelei.read(auth, (data) => {
            if (data.length > 0) {
                dispatch({ type: 'ROLE', payload: data });
            }
        }, 'model', 's-id=ASC');
    }
    return (
        <DropdownAction icon={<MoreOutlined />} buttonStyle={{ border: "none" }} items={[
            ...IfElse(!props?.object?.peremeshchenieVDrugoeROID &&
                !props?.object?.dokumentOtFederatsiiDlyaRassmotreniyaNaVikhodID &&
                !props?.object?.zayavlenieOtOrganizatoraNaVikhodID &&
                !props?.object?.dokumentVikhodaID, [{
                    ...props,
                    modal: { width: "700px" },
                    mode: "MenuItem",
                    auth: props.auth,
                    title: "Перемещение организатора в другое отделение",
                    form: PeremeshchenieVDrugoeRO,
                    action: (v, unlock, close, properties) => {
                        POST(props.auth, `/api/peremeshchenieorganizatoravdrugoero`, { organizatorID: props.object.ID, ...v }, ({ data }) => {
                            UpdateRoles();
                            close();
                        }, (err) => errorCatch(err, unlock))
                    }
                },
                {
                    ...props,
                    modal: { width: "700px" },
                    mode: "MenuItem",
                    auth: props.auth,
                    callback: props.callback,
                    object: props.object,
                    title: "Отменить регистрацию организатора в РО",
                    form: PodatZayavlenieNaOtmenuRegistratsiiOrganizatoraFederatsiiVEtomRegOt,
                    document: "podatzayavlenienaotmenuregistratsiiorganizatorafederatsiivetomregot",
                },
                ExtendedPropertiesAction(auth, 'для организатора федерации',
                    {
                        tipPolzovatelyaID: 23,
                        polzovatelID: user?.ID,
                        organizatorID: props?.object?.ID
                    },
                    [
                        MDXField("Общее описание", "", "ОбщееОписание", false, false),
                        MDXField("Танцевальные стили", "", "ТанцевальныеСтили", false, false),
                        MDXField("Общие достижения, как организатора", "", "Достижения", false, false),
                        MDXField("Организовывал мероприятия (какие именно, через запятую)", "", "МастерКлассыДавал", false, false),
                        MDXField("Сертификаты и аттестаты организатора", "", "СертификатыИАттестаты", false, false),
                        MDXField("Дополнительная информация", "", "ДополнительнаяИнформация", false, false),
                    ],
                    "MenuItem"
                )
            ], []),
            {
                ...props,
                modal: { width: "700px" },
                readonly: true,
                mode: "MenuItem",
                auth: props.auth,
                callback: props.callback,
                object: props.object,
                title: "Администраторы организатора",
                form: AdminOrg,
                action: () => { },
            }
        ]} />
    )
};
function BtnShkola(props) {
    const dispatch = useDispatch();
    const auth = useAuth();
    const user = useUserContext();
    const UpdateRoles = () => {
        CRUDE_VseTipiPolzovatelei.read(auth, (data) => {
            if (data.length > 0) {
                dispatch({ type: 'ROLE', payload: data });
            }
        }, 'model', 's-id=ASC');
    }
    return (
        <DropdownAction icon={<MoreOutlined />} buttonStyle={{ border: "none" }} items={[
            ...IfElse(!props?.object?.peremeshchenieVDrugoeROID &&
                !props?.object?.dokumentOtFederatsiiDlyaRassmotreniyaNaVikhodID &&
                !props?.object?.zayavlenieOtVladeltsaShkoliNaVikhodID &&
                !props?.object?.dokumentVikhodaIzFederatsiiID, [{
                    ...props,
                    modal: { width: "700px" },
                    mode: "MenuItem",
                    auth: props.auth,
                    // callback: props.callback,
                    // object: props.object,
                    title: "Перемещение школы в другое отделение",
                    form: PeremeshchenieVDrugoeRO,
                    // document: "peremeshchenieshkolivdrugoero",
                    action: (v, unlock, close, properties) => {
                        POST(props.auth, `/api/peremeshchenieshkolivdrugoero`, { shkolaID: props.object.ID, ...v }, ({ data }) => {
                            UpdateRoles();
                            close();
                        }, (err) => errorCatch(err, unlock))
                    }
                },
                {
                    ...props,
                    modal: { width: "700px" },
                    mode: "MenuItem",
                    auth: props.auth,
                    callback: props.callback,
                    object: props.object,
                    title: "Отменить регистрацию школы",
                    form: PodatZayavlenieNaAnnulirovanieLitsenziiShkoliFederatsii,
                    document: "podatzayavlenienaannulirovanielitsenziishkolifederatsii",
                },
                ExtendedPropertiesAction(auth, 'для школы федерации',
                    {
                        tipPolzovatelyaID: 18,
                        polzovatelID: user?.ID,
                        shkolaID: props?.object?.ID
                    },
                    [
                        MDXField("Общее описание сети школ", "", "ОбщееОписание", false, false),
                        MDXField("Танцевальные стили", "", "ТанцевальныеСтили", false, false),
                        MDXField("Достижения школы", "", "Достижения", false, false),
                        MDXField("В описании - год создания, 'Актуально с' - 'Дата создания'", "", "Опыт", false, false),
                        MDXField("Сертификаты и награды школы", "", "СертификатыИАттестаты", false, false),
                        MDXField("Дополнительная информация", "", "ДополнительнаяИнформация", false, false),
                    ],
                    "MenuItem"
                )
            ], []),
            {
                ...props,
                modal: { width: "700px" },
                readonly: true,
                mode: "MenuItem",
                auth: props.auth,
                callback: props.callback,
                object: props.object,
                title: "Администраторы школы",
                form: AdminSchool,
                action: () => { },
            },
            {
                ...props,
                mode: "MenuItem",
                auth: props.auth,
                action: (values, unlock, close) => {
                    goTo(`/app/school/${props.object.ID}/settings`)
                },
                title: "Настройки",
            },
        ]} />
    )
};


function BtnTantsorShkoli(props) {
    const dispatch = useDispatch();
    const auth = useAuth();
    const UpdateRoles = () => {
        CRUDE_VseTipiPolzovatelei.read(auth, (data) => {
            if (data.length > 0) {
                dispatch({ type: 'ROLE', payload: data });
            }
        }, 'model', 's-id=ASC');
    }
    let ID = _.get(props.object, "_role.ID");
    let items = [];

    if (!props?.object?._role?.uchenikiShkolVtp?.[0]?.osnovnaya && props?.object?._role?.dokumentPodtverzhdeniyaID) {
        items.push({
            title: "Сделать основной",
            action: (values, unlock, close, { collection, setCollection }) => {
                GET(auth, `/api/school/uchenikshkoli/osnovnaya/user/${ID}`,
                    () => {
                        // Придёт через сокет
                    }, errorCatch);
            },
        })
    }

    items.push({
        title: <span style={{ color: "red" }}>Удалить школу</span>,
        action: (values, unlock, close, { collection, setCollection }) => {
            Modal.confirm({
                title: `Вы уверены что хотите удалить школу?`,
                icon: <ExclamationCircleOutlined />,
                // content: <User item={item.vtp.user} noborder={true} />,
                okText: "Да",
                okType: 'danger',
                cancelText: "Нет",
                onOk: () => {
                    GET(auth, `/api/delete/school/uchenikshkoli/user/${ID}`,
                        () => {
                            // Придёт через сокет
                        }, errorCatch);
                },
            });
        },
    })

    return (
        <DropdownAction icon={<MoreOutlined />} buttonStyle={{ border: "none" }} items={items} />
    )
};
function BtnPrepodavatelShkoli(props) {
    const dispatch = useDispatch();
    const auth = useAuth();
    const UpdateRoles = () => {
        CRUDE_VseTipiPolzovatelei.read(auth, (data) => {
            if (data.length > 0) {
                dispatch({ type: 'ROLE', payload: data });
            }
        }, 'model', 's-id=ASC');
    }
    let ID = _.get(props.object, "_role.ID");
    return (
        <DropdownAction icon={<MoreOutlined />} buttonStyle={{ border: "none" }} items={[
            {
                title: "Удалить школу",
                action: (values, unlock, close, { collection, setCollection }) => {
                    Modal.confirm({
                        title: `Вы уверены что хотите удалить школу?`,
                        icon: <ExclamationCircleOutlined />,
                        // content: <User item={item.vtp.user} noborder={true} />,
                        okText: "Да",
                        okType: 'danger',
                        cancelText: "Нет",
                        onOk: () => {
                            GET(auth, `/api/delete/school/prepodavatel/user/${ID}`,
                                () => {
                                    // Придёт через сокет
                                }, errorCatch);
                        },
                    });

                },
            }
        ]} />
    )
};
function BtnKollektiv(props) {
    const dispatch = useDispatch();
    const auth = useAuth();
    const user = useUserContext();
    const UpdateRoles = () => {
        CRUDE_VseTipiPolzovatelei.read(auth, (data) => {
            if (data.length > 0) {
                dispatch({ type: 'ROLE', payload: data });
            }
        }, 'model', 's-id=ASC');
    }
    return (
        <DropdownAction icon={<MoreOutlined />} buttonStyle={{ border: "none" }} items={[
            {
                ...props,
                modal: { width: "700px" },
                mode: "MenuItem",
                auth: props.auth,
                callback: props.callback,
                object: props.object,
                title: "Отменить регистрацию коллектива",
                form: PodatZayavlenieNaAnnulirovanieLitsenziiKollektivaFederatsii,
                document: "podatzayavlenienaannulirovanielitsenziikollektivafederatsii",
            },
            ExtendedPropertiesAction(auth, 'для коллектива федерации',
                {
                    tipPolzovatelyaID: 20,
                    polzovatelID: user?.ID,
                    kollektivID: props?.object?.ID
                },
                [
                    MDXField("Общее описание", "", "ОбщееОписание", false, false),
                    MDXField("Танцевальные стили", "", "ТанцевальныеСтили", false, false),
                    MDXField("Места на соревнованиях, и т.д.", "", "Достижения", false, false),
                    MDXField("В описании - год создания, 'Актуально с' - 'Дата создания'", "", "Опыт", false, false),
                    MDXField("Школа танцев, художественный руководитель", "", "ШколаТанцевНезарегПринадлежу", false, false),
                    MDXField("Дополнительная информация", "", "ДополнительнаяИнформация", false, false),
                ],
                "MenuItem"
            )
        ]} />
    )
};
function BtnPari(props) {
    const { object } = props;
    const dispatch = useDispatch();
    const auth = useAuth();
    const user = useUserContext();
    const UpdateRoles = () => {
        CRUDE_VseTipiPolzovatelei.read(auth, (data) => {
            if (data.length > 0) {
                dispatch({ type: 'ROLE', payload: data });
            }
        }, 'model', 's-id=ASC');
    }

    const action = (values, unlock, close) => {
        POST(auth, "/api/polozhitelniiotvetnapredlozhenierukiiserdtsa", { paraID: object.ID },
            ({ data }) => {
                dispatch(REDUX_Pari.actions.updateArray([data]));
            },
            (err) => errorCatch(err, unlock));
    };
    const callback = (values, response, unlock, close, properties) => {
        // dispatch(REDUX_Pari.actions.updateArray([res.data]));
    };
    if (!object.dokumentPodtverzhdeniyaOtPartneraInitsiatoraPariID) {
        return (
            <DropdownAction icon={<MoreOutlined />} buttonStyle={{ border: "none" }} items={[
                {
                    ...props,
                    modal: { width: "400px" },
                    action: action,
                    mode: "MenuItem",
                    auth: props.auth,
                    object: props.object,
                    title: "Подтвердить создание пары",
                }
            ]} />
        )
    } else {
        return (
            <DropdownAction icon={<MoreOutlined />} buttonStyle={{ border: "none" }} items={[
                {
                    ...props,
                    modal: { width: "400px" },
                    mode: "MenuItem",
                    auth: props.auth,
                    object: props.object,
                    title: "Добавить региональное отделение",
                    callback: callback,
                    form: SamostoyatelnayaRegistratsiyaPariFederatsii,
                    document: "samostoyatelnayaregistratsiyaparifederatsii",
                },
                {
                    ...props,
                    modal: { width: "400px" },
                    // action: () => { },
                    mode: "MenuItem",
                    auth: props.auth,
                    object: props.object,
                    title: "Выйти из пары",
                    form: VikhodIzPari,
                    document: "vikhodizpari"
                },
                ExtendedPropertiesAction(auth, 'для пары федерации',
                    {
                        tipPolzovatelyaID: 17,
                        // polzovatelID: user?.ID, //Для пары не задаем пользователя
                        paraID: props?.object?.ID
                    },
                    [
                        MDXField("Общее описание", "", "ОбщееОписание", false, false),
                        MDXField("Танцевальные стили", "", "ТанцевальныеСтили", false, false),
                        MDXField("Места на соревнованиях, и т.д.", "", "Достижения", false, false),
                        MDXField("Давал мастер-классы", "", "МастерКлассыДавал", false, false),
                        MDXField("В описании - год создания, 'Актуально с' - 'Дата создания'", "", "Опыт", false, false),
                        MDXField("Совместно владеют школой", "", "ВладелецШколыНезарегистрированной", false, false),
                        MDXField("Представляют на соревнованиях школу", "", "ШколаТанцевНезарегПринадлежу", false, false),
                        MDXField("Дополнительная информация", "", "ДополнительнаяИнформация", false, false),
                    ],
                    "MenuItem"
                )
            ]} />
        )
    }
};

export default function CommonInfrastructureCurrentregistrations(props) {
    const classes = useStyles();
    const dispatch = useDispatch();
    const { status, auth } = props;

    const user = useSelector(state => state.home.user);

    const tantsor = useSelector(getTantsorFromRoles(["ТанцорФедерации"]));
    const shkola = useSelector(getShkolaFromRoles(["ВладелецШколыФедерации", "АдминистраторШколыФедерации"]));
    const para = useSelector(getParaFromRoles(["АдминистраторПарыФедерации"])); // Пара
    const kollektiv = useSelector(getKollektivFromRoles(["АдминистраторКоллективаФедерации"])); // Коллектив
    const prepodavatel = useSelector(getPrepodavatelFromRoles(["ПреподавательФедерации"])); // Преподаватель
    const sudya = useSelector(getSudyaFromRoles(["СудьяФедерации"])); // Судья
    const organizator = useSelector(getOrganizatorFromRoles(["ОрганизаторФедерации", "АдминистраторОрганизатораФедерации"])); // Организатор

    const tantsorShkoli = useSelector(getShkolaFromRoles(["УченикШколы"]));
    const prepodavatelShkoli = useSelector(getShkolaFromRoles(["ПреподавательШколы"]));

    const pari = useSelector(REDUX_Pari.selector.array);
    const zasedanie = useSelector(REDUX_ZasedaniyaPravleniyaFederatsii.selector.object, () => { });
    const chlenFederatsii = useSelector(getChlenFederatsiiFromRoles(["ЧленФедерации"]));

    const columnsChlen = [
        {
            // title: 'X',
            render: (text, record, index) => {
                if (!record.dokumentVstupleniyaID ||
                    (record.dokumentOtFederatsiiDlyaRassmotreniyaNaVikhodID ||
                        record.zayavlenieOtChlenaFederatsiiNaVikhodID)) {
                    if (!record.dokumentVstupleniyaID && record.dokumentPodachiZayavleniyaNaRegistratsiyuID) {
                        return (
                            <div>
                                Вступление в федерацию
                            </div>
                        );
                    }
                    if ((record.dokumentOtFederatsiiDlyaRassmotreniyaNaVikhodID ||
                        record.zayavlenieOtChlenaFederatsiiNaVikhodID) && !record.dokumentVikhodaIzFederatsiiID) {
                        return (
                            <div>
                                Исключение из федерации
                            </div>
                        );
                    }
                }
                return (<div>
                    Вступил в федерацию
                </div>);
            },
        },
        {
            title: '',
            render: (text, record, index) => {
                if (!record.dokumentVstupleniyaID ||
                    (record.dokumentOtFederatsiiDlyaRassmotreniyaNaVikhodID ||
                        record.zayavlenieOtChlenaFederatsiiNaVikhodID)) {
                    if (!record.dokumentVstupleniyaID && record.dokumentPodachiZayavleniyaNaRegistratsiyuID) {
                        return (
                            <div style={{ textAlign: "center" }}>
                                <Tooltip title="Ожидает решения заседания регионального правления о принятии члена федерации">
                                    <ExclamationOutlined style={{ color: "orange" }} />
                                </Tooltip>
                            </div>
                        );
                    }
                    if ((record.dokumentOtFederatsiiDlyaRassmotreniyaNaVikhodID ||
                        record.zayavlenieOtChlenaFederatsiiNaVikhodID) && !record.dokumentVikhodaIzFederatsiiID) {
                        return (
                            <div style={{ textAlign: "center" }}>
                                <Tooltip title="Ожидает решения заседания регионального правления о исключении члена федерации">
                                    <ExclamationOutlined style={{ color: "orange" }} />
                                </Tooltip>
                            </div>
                        );
                    }
                }
                return (<></>);
            },
        },
    ];

    const columnsTantsor = [
        {
            title: 'Региональное отделение',
            render: (text, record, index) => {
                return (
                    <span>{record.regionalnoeOtdelenie.nazvanie}</span>
                );
            }
        },
        {
            title: '',
            dataIndex: '',
            key: 'x',
            fixed: 'right',
            width: 45,
            render: (text, record, index) => {
                if (!record.dokumentRegistratsiiID ||
                    (record.peremeshchenieVDrugoeROID || record.dokumentOtFederatsiiDlyaRassmotreniyaNaVikhodID ||
                        record.zayavlenieOtTantsoraNaVikhodID)) {
                    if (!record.dokumentRegistratsiiID && record.dokumentPodachiZayavleniyaNaRegistratsiyuID) {
                        return (
                            <div style={{ textAlign: "center" }}>
                                <Tooltip title="Ожидает решения заседания регионального правления о принятии танцора федерации">
                                    <ExclamationOutlined style={{ color: "orange" }} />
                                </Tooltip>
                            </div>
                        );
                    }
                    if ((record.peremeshchenieVDrugoeROID || record.dokumentOtFederatsiiDlyaRassmotreniyaNaVikhodID ||
                        record.zayavlenieOtTantsoraNaVikhodID) && !record.dokumentVikhodaIzFederatsiiID) {
                        return (
                            <div style={{ textAlign: "center" }}>
                                <Tooltip title="Ожидает решения заседания регионального правления">
                                    <ExclamationOutlined style={{ color: "orange" }} />
                                </Tooltip>
                            </div>
                        );
                    }
                }
                return (<BtnTantsor auth={auth} object={record} callback={(values, response, unlock, close, properties) => {
                    // requestVoprosi(zasedaniya);
                }} />);
            },
        },
    ];
    const columnsSudya = [
        {
            title: 'Региональное отделение',
            render: (text, record, index) => {
                return (
                    <span>{record.regionalnoeOtdelenie.nazvanie}</span>
                );
            }
        },
        {
            title: '',
            dataIndex: '',
            key: 'x',
            fixed: 'right',
            width: 45,
            render: (text, record, index) => {
                // console.log(record)
                if (!record.dokumentRegistratsiiID ||
                    (record.peremeshchenieVDrugoeROID || record.dokumentOtFederatsiiDlyaRassmotreniyaNaVikhodID ||
                        record.zayavlenieOtSudiNaVikhodID)) {
                    if (!record.dokumentRegistratsiiID && record.dokumentPodachiZayavleniyaNaRegistratsiyuID) {
                        return (
                            <div style={{ textAlign: "center" }}>
                                <Tooltip title="Ожидает решения заседания регионального правления о принятии судьи федерации">
                                    <ExclamationOutlined style={{ color: "orange" }} />
                                </Tooltip>
                            </div>
                        );
                    }
                    if ((record.peremeshchenieVDrugoeROID || record.dokumentOtFederatsiiDlyaRassmotreniyaNaVikhodID ||
                        record.zayavlenieOtSudiNaVikhodID) && !record.dokumentVikhodaID) {
                        return (
                            <div style={{ textAlign: "center" }}>
                                <Tooltip title="Ожидает решения заседания регионального правления">
                                    <ExclamationOutlined style={{ color: "orange" }} />
                                </Tooltip>
                            </div>
                        );
                    }
                }
                return (<BtnSudya auth={auth} object={record} callback={(values, response, unlock, close, properties) => {
                    // requestVoprosi(zasedaniya);
                }} />);
            },
        },
    ];
    const columnsPrepodavatel = [
        {
            title: 'Региональное отделение',
            render: (text, record, index) => {
                return (
                    <span>{record.regionalnoeOtdelenie.nazvanie}</span>
                );
            }
        },
        {
            title: '',
            dataIndex: '',
            key: 'x',
            fixed: 'right',
            width: 45,
            render: (text, record, index) => {
                // console.log(record)
                if (!record.dokumentRegistratsiiID ||
                    (record.peremeshchenieVDrugoeROID || record.dokumentOtFederatsiiDlyaRassmotreniyaNaVikhodID ||
                        record.zayavlenieOtPrepodavatelyaNaVikhodID)) {
                    if (!record.dokumentRegistratsiiID && record.dokumentPodachiZayavleniyaNaRegistratsiyuID) {
                        return (
                            <div style={{ textAlign: "center" }}>
                                <Tooltip title="Ожидает решения заседания регионального правления о принятии преподавателя федерации">
                                    <ExclamationOutlined style={{ color: "orange" }} />
                                </Tooltip>
                            </div>
                        );
                    }
                    if ((record.peremeshchenieVDrugoeROID || record.dokumentOtFederatsiiDlyaRassmotreniyaNaVikhodID ||
                        record.zayavlenieOtPrepodavatelyaNaVikhodID) && !record.dokumentVikhodaID) {
                        return (
                            <div style={{ textAlign: "center" }}>
                                <Tooltip title="Ожидает решения заседания регионального правления">
                                    <ExclamationOutlined style={{ color: "orange" }} />
                                </Tooltip>
                            </div>
                        );
                    }
                }
                return (<BtnPrepodavatel auth={auth} object={record} callback={(values, response, unlock, close, properties) => {
                    // requestVoprosi(zasedaniya);
                }} />);
            },
        },
    ];
    const columnsOrganizator = [
        {
            title: 'Название',
            render: (text, record, index) => {
                return (
                    <span>{record.nazvanie}</span>
                );
            }
        },
        {
            title: 'Региональное отделение',
            render: (text, record, index) => {
                return (
                    <span>{record.regionalnoeOtdelenie.nazvanie}</span>
                );
            }
        },
        {
            title: '',
            dataIndex: '',
            key: 'x',
            fixed: 'right',
            width: 45,
            render: (text, record, index) => {
                // console.log(record)
                if (!record.dokumentRegistratsiiID ||
                    (record.peremeshchenieVDrugoeROID || record.dokumentOtFederatsiiDlyaRassmotreniyaNaVikhodID ||
                        record.zayavlenieOtOrganizatoraNaVikhodID)) {
                    if (!record.dokumentRegistratsiiID && record.dokumentPodachiZayavleniyaNaRegistratsiyuID) {
                        return (
                            <div style={{ textAlign: "center" }}>
                                <Tooltip title="Ожидает решения заседания регионального правления о принятии организатора федерации">
                                    <ExclamationOutlined style={{ color: "orange" }} />
                                </Tooltip>
                            </div>
                        );
                    }
                    if ((record.peremeshchenieVDrugoeROID || record.dokumentOtFederatsiiDlyaRassmotreniyaNaVikhodID ||
                        record.zayavlenieOtOrganizatoraNaVikhodID) && !record.dokumentVikhodaID) {
                        return (
                            <div style={{ textAlign: "center" }}>
                                <Tooltip title="Ожидает решения заседания регионального правления">
                                    <ExclamationOutlined style={{ color: "orange" }} />
                                </Tooltip>
                            </div>
                        );
                    }
                }
                return (<BtnOrganizator auth={auth} object={record} callback={(values, response, unlock, close, properties) => {
                    // requestVoprosi(zasedaniya);
                }} />);
            },
        },
    ];
    const columnsShkola = [
        {
            title: 'Название',
            render: (text, record, index) => {
                return (
                    <span>{record.nazvanieShkoliTantsev}</span>
                );
            }
        },
        {
            title: 'Региональное отделение',
            render: (text, record, index) => {
                return (
                    <span>{record.regionalnoeOtdelenie.nazvanie}</span>
                );
            }
        },
        {
            title: '',
            dataIndex: '',
            key: 'x',
            fixed: 'right',
            width: 45,
            render: (text, record, index) => {
                // console.log(record)
                if (!record.dokumentRegistratsiiID ||
                    (record.peremeshchenieVDrugoeROID || record.dokumentOtFederatsiiDlyaRassmotreniyaNaVikhodID ||
                        record.zayavlenieOtVladeltsaShkoliNaVikhodID)) {
                    if (!record.dokumentRegistratsiiID && record.dokumentPodachiZayavleniyaNaRegistratsiyuID) {
                        return (
                            <div style={{ textAlign: "center" }}>
                                <Tooltip title="Ожидает решения заседания регионального правления о принятии школы федерации">
                                    <ExclamationOutlined style={{ color: "orange" }} />
                                </Tooltip>
                            </div>
                        );
                    }
                    if ((record.peremeshchenieVDrugoeROID || record.dokumentOtFederatsiiDlyaRassmotreniyaNaVikhodID ||
                        record.zayavlenieOtVladeltsaShkoliNaVikhodID) && !record.dokumentVikhodaIzFederatsiiID) {
                        return (
                            <div style={{ textAlign: "center" }}>
                                <Tooltip title="Ожидает решения заседания регионального правления">
                                    <ExclamationOutlined style={{ color: "orange" }} />
                                </Tooltip>
                            </div>
                        );
                    }
                }
                return (<BtnShkola auth={auth} object={record} callback={(v, unlock, close, properties) => {

                }} />);
            },
        },
    ];

    const columnsTantsorShkoli = [
        {
            title: 'Название',
            render: (text, record, index) => {
                return (
                    <span>{record.nazvanieShkoliTantsev}</span>
                );
            }
        },
        {
            title: 'Региональное отделение',
            render: (text, record, index) => {
                return (
                    <span>{record.regionalnoeOtdelenie.nazvanie}</span>
                );
            }
        },
        {
            title: 'Основная',
            render: (text, record, index) => {
                return (
                    <span>{(record?._role?.uchenikiShkolVtp?.[0]?.osnovnaya) ? "Основная" : ""}</span>
                );
            }
        },
        {
            title: '',
            dataIndex: '',
            key: 'w',
            fixed: 'right',
            width: 45,
            render: (text, record, index) => {
                if (!record?._role?.dokumentPodtverzhdeniyaID) {
                    return (
                        <div style={{ textAlign: "center" }}>
                            <Tooltip title="Ожидает подтверждения школой федерации">
                                <ExclamationOutlined style={{ color: "orange" }} />
                            </Tooltip>
                        </div>
                    );
                }
                return;
            },
        },
        {
            title: '',
            dataIndex: '',
            key: 'x',
            fixed: 'right',
            width: 45,
            render: (text, record, index) => {
                return (<BtnTantsorShkoli key={uuid()} auth={auth} object={record} callback={(values, response, unlock, close, properties) => {
                    // requestVoprosi(zasedaniya);
                }} />);
            },
        },
    ];
    const columnsPrepodavatelShkoli = [
        {
            title: 'Название',
            render: (text, record, index) => {
                return (
                    <span>{record.nazvanieShkoliTantsev}</span>
                );
            }
        },
        {
            title: 'Региональное отделение',
            render: (text, record, index) => {
                return (
                    <span>{record.regionalnoeOtdelenie.nazvanie}</span>
                );
            }
        },
        {
            title: '',
            dataIndex: '',
            key: 'w',
            fixed: 'right',
            width: 45,
            render: (text, record, index) => {
                if (!record?._role?.dokumentPodtverzhdeniyaID) {
                    return (
                        <div style={{ textAlign: "center" }}>
                            <Tooltip title="Ожидает подтверждения школой федерации">
                                <ExclamationOutlined style={{ color: "orange" }} />
                            </Tooltip>
                        </div>
                    );
                }
                return;
            },
        },
        {
            title: '',
            dataIndex: '',
            key: 'x',
            fixed: 'right',
            width: 45,
            render: (text, record, index) => {
                return (<BtnPrepodavatelShkoli auth={auth} object={record} callback={(values, response, unlock, close, properties) => {
                    // requestVoprosi(zasedaniya);
                }} />);
            },
        },
    ];
    const columnsKollektiv = [
        {
            title: 'Коллектив',
            render: (text, record, index) => {
                return (
                    <span>{record.nazvanieKollektiva}</span>
                );
            }
        },
        {
            title: 'Школа',
            render: (text, record, index) => {
                return (
                    <span>{record.shkolaFederatsii.nazvanieShkoliTantsev}</span>
                );
            }
        },
        {
            title: '',
            dataIndex: '',
            key: 'x',
            fixed: 'right',
            width: 45,
            render: (text, record, index) => {
                // console.log(record)
                if (!record.dokumentRegistratsiiID ||
                    (record.dokumentOtFedDlyaRassmNaRasformKollektiva ||
                        record.zayavlenieOtVladeltsaShkoliNaRasformirovanieKollektiva)) {
                    if (!record.dokumentRegistratsiiID && record.dokumentPodachiZayavleniyaNaRegistratsiyuID) {
                        return (
                            <div style={{ textAlign: "center" }}>
                                <Tooltip title="Ожидает решения заседания регионального правления о принятии коллектива федерации">
                                    <ExclamationOutlined style={{ color: "orange" }} />
                                </Tooltip>
                            </div>
                        );
                    }
                    if ((record.dokumentOtFedDlyaRassmNaRasformKollektiva ||
                        record.zayavlenieOtVladeltsaShkoliNaRasformirovanieKollektiva) && !record.dokumentRasformirovaniyaKollektiva) {
                        return (
                            <div style={{ textAlign: "center" }}>
                                <Tooltip title="Ожидает решения заседания регионального правления о исключении коллектива федерации">
                                    <ExclamationOutlined style={{ color: "orange" }} />
                                </Tooltip>
                            </div>
                        );
                    }
                }
                return (<BtnKollektiv auth={auth} object={record} callback={(values, response, unlock, close, properties) => {
                    // requestVoprosi(zasedaniya);
                }} />);
            },
        },
    ];
    const columnsPari = [
        {
            title: 'Пара',
            render: (text, record, index) => {
                if (!record.dokumentPodtverzhdeniyaOtPartneraInitsiatoraPariID) {
                    return (
                        <>
                            {/* <Badge dot={true} offset={[5, 0]}> */}
                            <Badge status="error" />
                            <span>{record.partner.lastname} {record.partner.firstname} - {record.partnersha.lastname} {record.partnersha.firstname}</span>
                            {/* </Badge> */}
                        </>
                    );
                } else {
                    return (
                        <>
                            <span>{record.partner.lastname} {record.partner.firstname} - {record.partnersha.lastname} {record.partnersha.firstname}</span>
                        </>
                    );
                }
            }
        },
        {
            title: 'Рег. отделения',
            render: (text, record, index) => {
                const o = para.filter(i => i.paraID == record.ID).map(i => {

                    // if (!i.dokumentRegistratsiiID || (i.dokumentOtFederatsiiDlyaRassmotreniyaNaVikhodID || i.zayavlenieOtPartneraNaVikhodID)) {
                    if (!i.dokumentRegistratsiiID && i.dokumentPodachiZayavleniyaNaRegistratsiyuID) {
                        return (<Action {...props} key={i.ID}
                            modal={{ width: "400px" }}
                            mode={"Tag"}
                            color="orange"
                            closable={false}
                            tooltip={"Ожидает решения заседания регионального правления о регистрации пары"}
                            auth={props.auth}
                            object={i}
                            title={i.regionalnoeOtdelenie.nazvanie}
                            // callback={callback}
                            form={PodatZayavlenieNaOtmenuRegistratsiiPariFederatsiiVEtomRegOt}
                            document={"podatzayavlenienaotmenuregistratsiiparifederatsiivetomregot"}
                        />);
                    }
                    if (i.dokumentRegistratsiiID && (i.dokumentOtFederatsiiDlyaRassmotreniyaNaVikhodID ||
                        i.zayavlenieOtPartneraNaVikhodID) && !i.dokumentVikhodaIzFederatsiiID) {
                        return (<Action {...props} key={i.ID}
                            modal={{ width: "400px" }}
                            mode={"Tag"}
                            color="orange"
                            closable={false}
                            tooltip={"Ожидает решения заседания регионального правления о выходе пары из регионального отделения"}
                            auth={props.auth}
                            object={i}
                            title={i.regionalnoeOtdelenie.nazvanie}
                            // callback={callback}
                            form={PodatZayavlenieNaOtmenuRegistratsiiPariFederatsiiVEtomRegOt}
                            document={"podatzayavlenienaotmenuregistratsiiparifederatsiivetomregot"}
                        />);
                    }
                    // }
                    return (
                        <Action {...props} key={i.ID}
                            modal={{ width: "400px", title: "Отменить регистрацию пары в региональном отделении " + i.regionalnoeOtdelenie.nazvanie }}
                            mode={"Tag"}
                            closable={true}
                            auth={props.auth}
                            object={i}
                            title={i.regionalnoeOtdelenie.nazvanie}
                            // callback={callback}
                            form={PodatZayavlenieNaOtmenuRegistratsiiPariFederatsiiVEtomRegOt}
                            document={"podatzayavlenienaotmenuregistratsiiparifederatsiivetomregot"}
                        />
                    );
                });
                return (o);
            }
        },
        {
            title: '',
            dataIndex: '',
            key: 'x',
            fixed: 'right',
            width: 45,
            render: (text, record, index) => {
                //console.log(record);
                if (!record.dokumentPodtverzhdeniyaOtPartneraInitsiatoraPariID) {
                    if (record.dokPodachiZayavlNaRegistratsiyuOtInitsiatoraPari.creatorID == user.ID) {
                        return (
                            <div style={{ textAlign: "center" }}>
                                <Tooltip title="Ожидает подтверждения от партнера">
                                    <ExclamationOutlined style={{ color: "orange" }} />
                                </Tooltip>
                            </div>
                        );
                    }
                    // cancel - "Выйти из пары" до подтверждения
                }
                return (<BtnPari auth={auth} object={record} callback={(values, response, unlock, close, properties) => {
                    // PolozhitelniiOtvetNaPredlozhenieRukiISerdtsa
                    // Pari
                }} />);
            },
        },
    ];
    const update_pari = (values, response, unlock, close, properties) => {
        dispatch(REDUX_Pari.actions.updateArray([response.data]));
    };
    const ctx = {
        chlenFederatsii,
        tantsor,
        shkola,
        para,
        kollektiv,
        prepodavatel,
        sudya,
        organizator,

        tantsorShkoli,
        prepodavatelShkoli,

        pari,
        zasedanie
    };

    return (
        <PageLayout hideBreadcrumbs={true}>
            <div style={{ backgroundColor: "white", borderRadius: "4px" }}>
                <div style={{ padding: "10px" }}>
                    <div>
                        <div style={{ display: "flex", justifyContent: "space-between", marginBottom: "10px", marginTop: "25px", paddingRight: "10px" }}>
                            <div style={{
                                fontFamily: "-apple-system, BlinkMacSystemFont, Roboto, 'Open Sans', 'Helvetica Neue', 'Noto Sans Armenian', 'Noto Sans Bengali', 'Noto Sans Cherokee', 'Noto Sans Devanagari', 'Noto Sans Ethiopic', 'Noto Sans Georgian', 'Noto Sans Hebrew', 'Noto Sans Kannada', 'Noto Sans Khmer', 'Noto Sans Lao', 'Noto Sans Osmanya', 'Noto Sans Tamil', 'Noto Sans Telugu', 'Noto Sans Thai', sans-serif",
                                fontSize: "13px",
                                fontWeight: "600",
                                color: "rgb(0, 0, 0)",
                            }}>
                                Пользователь
                            </div>
                            <div style={{ flex: "auto", margin: "10px 10px", height: "1px", backgroundColor: "#f0f0f0" }}></div>
                            <DropdownAction
                                items={[
                                    ExtendedPropertiesAction(auth, 'для пользователя',
                                        {
                                            polzovatelID: user?.ID
                                        },
                                        [
                                            ImagesField("1x1", "vertical", "round", "Файлы для аватарок", "", "AVATAR_FILES", false, false, 4),
                                            // ImagesField("16x9", "horizontal", "rect", "Файлы экранов (16x9)","","SCREENS_FILES_16x9",false,false, 3),
                                            // ImagesField("3x1", "horizontal", "rect", "Файлы экранов (3x1)","","VKHEAD_FILES_3x1",false,false, 4),
                                            // ImagesField("16x9", "vertical", "rect", "Файлы экранов (9x16)","","SCREENS_FILES_9x16",false,false),
                                            // ImagesField("4x3", "vertical", "rect", "Файлы экранов (4x3)","","SCREENS_FILES_4x3",false,false),
                                            VideosField("Видео", "", "VIDEO", false, false, 3),
                                            MDXField("Владелец школ, незарегистрированных в личном кабинете (через запятую)", "", "ВладелецШколыНезарегистрированной", false, false),
                                            MDXField("Дополнительная информация", "", "ДополнительнаяИнформация", false, false),
                                        ],
                                        "MenuItem",
                                        true
                                    )
                                ]} />
                        </div>
                    </div>
                    <div>
                        <div style={{ display: "flex", justifyContent: "space-between", marginBottom: "10px", marginTop: "25px", paddingRight: "10px" }}>
                            <div style={{
                                fontFamily: "-apple-system, BlinkMacSystemFont, Roboto, 'Open Sans', 'Helvetica Neue', 'Noto Sans Armenian', 'Noto Sans Bengali', 'Noto Sans Cherokee', 'Noto Sans Devanagari', 'Noto Sans Ethiopic', 'Noto Sans Georgian', 'Noto Sans Hebrew', 'Noto Sans Kannada', 'Noto Sans Khmer', 'Noto Sans Lao', 'Noto Sans Osmanya', 'Noto Sans Tamil', 'Noto Sans Telugu', 'Noto Sans Thai', sans-serif",
                                fontSize: "13px",
                                fontWeight: "600",
                                color: "rgb(0, 0, 0)",
                            }}>
                                Танцор федерации
                            </div>
                            <div style={{ flex: "auto", margin: "10px 10px", height: "1px", backgroundColor: "#f0f0f0" }}></div>
                            <DropdownAction items={[
                                IFTrue("samostoyatelnayaregistratsiyatantsorafederatsii", {
                                    ...props,
                                    mode: "MenuItem",
                                    title: "Зарегистрироваться, как Танцор Федерации",
                                    form: SamostoyatelnayaRegistratsiyaTantsoraFederatsii,
                                    document: "samostoyatelnayaregistratsiyatantsorafederatsii",
                                }, undefined, ctx),
                                IFTrue("not-samostoyatelnayaregistratsiyatantsorafederatsii", {
                                    ...props,
                                    mode: "MenuItem",
                                    title: "Зарегистрироваться, как Танцор Федерации в еще одном РО",
                                    form: SamostoyatelnayaRegistratsiyaTantsoraFederatsii,
                                    document: "samostoyatelnayaregistratsiyatantsorafederatsii",
                                }, undefined, ctx),
                                ExtendedPropertiesAction(auth, 'для всех объектов "Танцор федерации"',
                                    {
                                        tantsorID: null,
                                        tipPolzovatelyaID: 16,
                                        polzovatelID: user?.ID
                                    },
                                    [
                                        MDXField("Общее описание", "", "ОбщееОписание", false, false),
                                        MDXField("Танцевальные стили", "", "ТанцевальныеСтили", false, false),
                                        MDXField("Танцевальное образование", "", "ТанцевальноеОбразование", false, false),
                                        MDXField("У кого обучался", "", "УКогоОбучался", false, false),
                                        MDXField("Занятые места на соревнованиях, и т.д.", "", "Достижения", false, false),
                                        MDXField("МК и фестивали, которые посещал (через запятую)", "", "ФестивалиМКПосещал", false, false),
                                        MDXField("Сертификаты и аттестаты, обучающих курсов, как танцора", "", "СертификатыИАттестаты", false, false),
                                        MDXField("Занимаюсь в школах танцев (в каких и по каким направлениям), Указать все школы, даже те, в которых зарегистрирован в личном кабинете.", "", "ШколаТанцевНезарегПринадлежу", false, false),
                                        MDXField("Дополнительная информация", "", "ДополнительнаяИнформация", false, false),
                                    ],
                                    "MenuItem"
                                ),
                            ]} />
                        </div>
                        <Rule type={"samostoyatelnayaregistratsiyatantsorafederatsii"}>
                            <div className={classes.actionTitle}>
                                Не являюсь Танцором Федерации
                            </div>
                        </Rule>
                        <Rule type={"not-samostoyatelnayaregistratsiyatantsorafederatsii"}>
                            <Table className={classes.table} columns={columnsTantsor} dataSource={tantsor} bordered={false} pagination={false} showHeader={false} style={{ paddingBottom: "15px" }} locale={{ emptyText: <Empty description={""}></Empty> }} size="small" rowKey={(r) => r.ID} />
                        </Rule>
                    </div>
                    <div>
                        <div style={{ display: "flex", justifyContent: "space-between", marginBottom: "10px", marginTop: "25px", paddingRight: "10px" }}>
                            <div style={{
                                fontFamily: "-apple-system, BlinkMacSystemFont, Roboto, 'Open Sans', 'Helvetica Neue', 'Noto Sans Armenian', 'Noto Sans Bengali', 'Noto Sans Cherokee', 'Noto Sans Devanagari', 'Noto Sans Ethiopic', 'Noto Sans Georgian', 'Noto Sans Hebrew', 'Noto Sans Kannada', 'Noto Sans Khmer', 'Noto Sans Lao', 'Noto Sans Osmanya', 'Noto Sans Tamil', 'Noto Sans Telugu', 'Noto Sans Thai', sans-serif",
                                fontSize: "13px",
                                fontWeight: "600",
                                color: "rgb(0, 0, 0)",
                            }}>
                                Судья федерации
                            </div>
                            <div style={{ flex: "auto", margin: "10px 10px", height: "1px", backgroundColor: "#f0f0f0" }}></div>
                            <DropdownAction items={[
                                IFTrue("samostoyatelnayaregistratsiyasudifederatsii", {
                                    ...props,
                                    mode: "MenuItem",
                                    title: "Зарегистрироваться, как Судья Федерации",
                                    form: SamostoyatelnayaRegistratsiyaSudiFederatsii,
                                    document: "samostoyatelnayaregistratsiyasudifederatsii",
                                }, undefined, ctx),
                                IFTrue("not-samostoyatelnayaregistratsiyasudifederatsii", {
                                    ...props,
                                    mode: "MenuItem",
                                    title: "Зарегистрироваться, как Судья Федерации в еще одном РО",
                                    form: SamostoyatelnayaRegistratsiyaSudiFederatsii,
                                    document: "samostoyatelnayaregistratsiyasudifederatsii"
                                }, undefined, ctx),
                                IFTrue("not-samostoyatelnayaregistratsiyasudifederatsii", {
                                    auth: auth,
                                    title: "Судейская аттестация",
                                    action: (values, unlock, close) => {
                                        goTo(`/app/testing`)
                                    },
                                    mode: "MenuItem",
                                }, undefined, ctx),
                                ExtendedPropertiesAction(auth, 'для всех объектов "Судья федерации"',
                                    {
                                        tipPolzovatelyaID: 22,
                                        polzovatelID: user?.ID,
                                        sudyaID: null
                                    },
                                    [
                                        MDXField("Общее описание", "", "ОбщееОписание", false, false),
                                        MDXField("Танцевальные стили", "", "ТанцевальныеСтили", false, false),
                                        MDXField("Достижения, как преподавателя (вырастил сколько танцоров, какие они места занимали на соревнованиях)", "", "Достижения", false, false),
                                        MDXField("Давал МК (в каких городах и на каких Фестивалях? Пишем через запятую)", "", "МастерКлассыДавал", false, false),
                                        MDXField("Опыт судейства", "", "Опыт", false, false),
                                        MDXField("Сертификаты и аттестаты, подтверждающие судейскую квалификацию и преподавательские курсы", "", "СертификатыИАттестаты", false, false),
                                        MDXField("Дополнительная информация", "", "ДополнительнаяИнформация", false, false),
                                    ],
                                    "MenuItem"
                                ),
                            ]} />
                        </div>
                        <Rule type={"samostoyatelnayaregistratsiyasudifederatsii"}>
                            <div className={classes.actionTitle}>
                                Не являюсь Судьей Федерации
                            </div>
                        </Rule>
                        <Rule type={"not-samostoyatelnayaregistratsiyasudifederatsii"}>
                            <Table className={classes.table} columns={columnsSudya} dataSource={sudya} bordered={false} pagination={false} showHeader={false} style={{ paddingBottom: "15px" }} locale={{ emptyText: <Empty description={""}></Empty> }} size="small" rowKey={(r) => r.ID} />
                        </Rule>
                    </div>
                    <div>
                        <div style={{ display: "flex", justifyContent: "space-between", marginBottom: "10px", marginTop: "25px", paddingRight: "10px" }}>
                            <div style={{
                                fontFamily: "-apple-system, BlinkMacSystemFont, Roboto, 'Open Sans', 'Helvetica Neue', 'Noto Sans Armenian', 'Noto Sans Bengali', 'Noto Sans Cherokee', 'Noto Sans Devanagari', 'Noto Sans Ethiopic', 'Noto Sans Georgian', 'Noto Sans Hebrew', 'Noto Sans Kannada', 'Noto Sans Khmer', 'Noto Sans Lao', 'Noto Sans Osmanya', 'Noto Sans Tamil', 'Noto Sans Telugu', 'Noto Sans Thai', sans-serif",
                                fontSize: "13px",
                                fontWeight: "600",
                                color: "rgb(0, 0, 0)",
                            }}>
                                Преподаватель федерации
                            </div>
                            <div style={{ flex: "auto", margin: "10px 10px", height: "1px", backgroundColor: "#f0f0f0" }}></div>
                            <DropdownAction items={[
                                IFTrue("samostoyatelnayaregistratsiyaprepodavatelyafederatsii", {
                                    ...props,
                                    mode: "MenuItem",
                                    title: "Зарегистрироваться, как Преподаватель Федерации",
                                    form: SamostoyatelnayaRegistratsiyaPrepodavatelyaFederatsii,
                                    document: "samostoyatelnayaregistratsiyaprepodavatelyafederatsii"
                                }, undefined, ctx),
                                IFTrue("not-samostoyatelnayaregistratsiyaprepodavatelyafederatsii", {
                                    ...props,
                                    mode: "MenuItem",
                                    title: "Зарегистрироваться, как Преподаватель Федерации в еще одном РО",
                                    form: SamostoyatelnayaRegistratsiyaPrepodavatelyaFederatsii,
                                    document: "samostoyatelnayaregistratsiyaprepodavatelyafederatsii"
                                }, undefined, ctx),
                                ExtendedPropertiesAction(auth, 'для всех объектов "Преподаватель федерации"',
                                    {
                                        prepodavatelID: null,
                                        tipPolzovatelyaID: 21,
                                        polzovatelID: user?.ID
                                    },
                                    [
                                        MDXField("Общее описание", "", "ОбщееОписание", false, false),
                                        MDXField("Дополнительная информация", "", "ДополнительнаяИнформация", false, false),
                                    ],
                                    "MenuItem"
                                ),
                            ]} />
                        </div>
                        <Rule type={"samostoyatelnayaregistratsiyaprepodavatelyafederatsii"}>
                            <div className={classes.actionTitle}>
                                Не являюсь Преподавателем Федерации
                            </div>
                        </Rule>
                        <Rule type={"not-samostoyatelnayaregistratsiyaprepodavatelyafederatsii"}>
                            <Table className={classes.table} columns={columnsPrepodavatel} dataSource={prepodavatel} bordered={false} pagination={false} showHeader={false} style={{ paddingBottom: "15px" }} locale={{ emptyText: <Empty description={""}></Empty> }} size="small" rowKey={(r) => r.ID} />
                        </Rule>
                    </div>
                    <div>
                        <div style={{ display: "flex", justifyContent: "space-between", marginBottom: "10px", marginTop: "25px", paddingRight: "10px" }}>
                            <div style={{
                                fontFamily: "-apple-system, BlinkMacSystemFont, Roboto, 'Open Sans', 'Helvetica Neue', 'Noto Sans Armenian', 'Noto Sans Bengali', 'Noto Sans Cherokee', 'Noto Sans Devanagari', 'Noto Sans Ethiopic', 'Noto Sans Georgian', 'Noto Sans Hebrew', 'Noto Sans Kannada', 'Noto Sans Khmer', 'Noto Sans Lao', 'Noto Sans Osmanya', 'Noto Sans Tamil', 'Noto Sans Telugu', 'Noto Sans Thai', sans-serif",
                                fontSize: "13px",
                                fontWeight: "600",
                                color: "rgb(0, 0, 0)",
                            }}>
                                Организатор федерации
                            </div>
                            <div style={{ flex: "auto", margin: "10px 10px", height: "1px", backgroundColor: "#f0f0f0" }}></div>
                            <DropdownAction items={[
                                IFTrue("samostoyatelnayaregistratsiyaorganizatora", {
                                    ...props,
                                    mode: "MenuItem",
                                    title: "Зарегистрироваться, как Организатор Федерации",
                                    form: SamostoyatelnayaRegistratsiyaOrganizatora,
                                    document: "samostoyatelnayaregistratsiyaorganizatora"
                                }, undefined, ctx),
                                IFTrue("not-samostoyatelnayaregistratsiyaorganizatora", {
                                    ...props,
                                    mode: "MenuItem",
                                    title: "Зарегистрироваться, как Организатор Федерации в еще одном РО",
                                    form: SamostoyatelnayaRegistratsiyaOrganizatora,
                                    document: "samostoyatelnayaregistratsiyaorganizatora"
                                }, undefined, ctx),
                                ExtendedPropertiesAction(auth, 'для всех объектов "Организатор федерации"',
                                    {
                                        organizatorID: null,
                                        tipPolzovatelyaID: 23,
                                        polzovatelID: user?.ID
                                    },
                                    [
                                        MDXField("Общее описание", "", "ОбщееОписание", false, false),
                                        MDXField("Танцевальные стили", "", "ТанцевальныеСтили", false, false),
                                        MDXField("Общие достижения, как организатора", "", "Достижения", false, false),
                                        MDXField("Давал мастер-классы", "", "МастерКлассыДавал", false, false),
                                        MDXField("Сертификаты и аттестаты организатора", "", "СертификатыИАттестаты", false, false),
                                        MDXField("Дополнительная информация", "", "ДополнительнаяИнформация", false, false),
                                    ],
                                    "MenuItem"
                                ),
                            ]} />
                        </div>
                        <Rule type={"samostoyatelnayaregistratsiyaorganizatora"}>
                            <div className={classes.actionTitle}>
                                Не являюсь Организатором Федерации
                            </div>
                        </Rule>
                        <Rule type={"not-samostoyatelnayaregistratsiyaorganizatora"}>
                            <Table className={classes.table} columns={columnsOrganizator} dataSource={organizator} bordered={false} pagination={false} showHeader={false} style={{ paddingBottom: "15px" }} locale={{ emptyText: <Empty description={""}></Empty> }} size="small" rowKey={(r) => r.ID} />
                        </Rule>
                    </div>
                    <div>
                        <div style={{ display: "flex", justifyContent: "space-between", marginBottom: "10px", marginTop: "25px", paddingRight: "10px" }}>
                            <div style={{
                                fontFamily: "-apple-system, BlinkMacSystemFont, Roboto, 'Open Sans', 'Helvetica Neue', 'Noto Sans Armenian', 'Noto Sans Bengali', 'Noto Sans Cherokee', 'Noto Sans Devanagari', 'Noto Sans Ethiopic', 'Noto Sans Georgian', 'Noto Sans Hebrew', 'Noto Sans Kannada', 'Noto Sans Khmer', 'Noto Sans Lao', 'Noto Sans Osmanya', 'Noto Sans Tamil', 'Noto Sans Telugu', 'Noto Sans Thai', sans-serif",
                                fontSize: "13px",
                                fontWeight: "600",
                                color: "rgb(0, 0, 0)",
                            }}>
                                Владелец школы федерации
                            </div>
                            <div style={{ flex: "auto", margin: "10px 10px", height: "1px", backgroundColor: "#f0f0f0" }}></div>
                            <DropdownAction items={[
                                IFTrue("samostoyatelnayaregistratsiyashkolifederatsii", {
                                    ...props,
                                    mode: "MenuItem",
                                    title: "Зарегистрировать танцевальную школу, владельцем которой я являюсь",
                                    form: SamostoyatelnayaRegistratsiyaShkoliFederatsii,
                                    document: "samostoyatelnayaregistratsiyashkolifederatsii"
                                }, undefined, ctx),
                                IFTrue("not-samostoyatelnayaregistratsiyashkolifederatsii", {
                                    ...props,
                                    mode: "MenuItem",
                                    title: "Зарегистрировать еще одну танцевальную школу, владельцем которой я являюсь",
                                    form: SamostoyatelnayaRegistratsiyaShkoliFederatsii,
                                    document: "samostoyatelnayaregistratsiyashkolifederatsii"
                                }, undefined, ctx),
                                ExtendedPropertiesAction(auth, 'для всех объектов "Школа федерации"',
                                    {
                                        shkolaID: null,
                                        tipPolzovatelyaID: 18,
                                        polzovatelID: user?.ID
                                    },
                                    [
                                        MDXField("Общее описание сети школ", "", "ОбщееОписание", false, false),
                                        MDXField("Танцевальные стили", "", "ТанцевальныеСтили", false, false),
                                        MDXField("Достижения школы", "", "Достижения", false, false),
                                        MDXField("В описании - год создания, 'Актуально с' - 'Дата создания'", "", "Опыт", false, false),
                                        MDXField("Сертификаты и награды школы", "", "СертификатыИАттестаты", false, false),
                                        MDXField("Дополнительная информация", "", "ДополнительнаяИнформация", false, false),
                                    ],
                                    "MenuItem"
                                ),
                            ]} />
                        </div>
                        <Rule type={"samostoyatelnayaregistratsiyashkolifederatsii"}>
                            <div className={classes.actionTitle}>
                                Не являюсь владельцем Танцевальной Школы
                            </div>
                        </Rule>
                        <Rule type={"not-samostoyatelnayaregistratsiyashkolifederatsii"}>
                            <Table className={classes.table} columns={columnsShkola} dataSource={shkola} bordered={false} pagination={false} showHeader={false} style={{ paddingBottom: "15px" }} locale={{ emptyText: <Empty description={""}></Empty> }} size="small" rowKey={(r) => r.ID} />
                        </Rule>
                    </div>
                    <div>
                        <div style={{ display: "flex", justifyContent: "space-between", marginBottom: "10px", marginTop: "25px", paddingRight: "10px" }}>
                            <div style={{
                                fontFamily: "-apple-system, BlinkMacSystemFont, Roboto, 'Open Sans', 'Helvetica Neue', 'Noto Sans Armenian', 'Noto Sans Bengali', 'Noto Sans Cherokee', 'Noto Sans Devanagari', 'Noto Sans Ethiopic', 'Noto Sans Georgian', 'Noto Sans Hebrew', 'Noto Sans Kannada', 'Noto Sans Khmer', 'Noto Sans Lao', 'Noto Sans Osmanya', 'Noto Sans Tamil', 'Noto Sans Telugu', 'Noto Sans Thai', sans-serif",
                                fontSize: "13px",
                                fontWeight: "600",
                                color: "rgb(0, 0, 0)",
                            }}>
                                Занимаюсь в школах
                            </div>
                            <div style={{ flex: "auto", margin: "10px 10px", height: "1px", backgroundColor: "#f0f0f0" }}></div>
                            <DropdownAction items={[{
                                ...props,
                                mode: "MenuItem",
                                title: "Добавить танцевальную школу, в которой я занимаюсь",
                                form: RegistratsiyaTantsoraShkoli,
                                action: (values, unlock, close) => {
                                    GET(auth, `/api/podatzayavlenienaregistratsiuuchenikaschool/${values.shkolaID}`,
                                        ({ data }) => {
                                            // console.log(data);
                                            close();
                                        }, (err) => errorCatch(err, () => unlock()));
                                },
                            }]} />
                        </div>
                        {(tantsorShkoli && tantsorShkoli.length <= 0) && <div className={classes.actionTitle}>
                            Не занимаюсь в танцевальных школах
                        </div>}
                        {(tantsorShkoli && tantsorShkoli.length > 0) && <div>
                            <Table className={classes.table} columns={columnsTantsorShkoli} dataSource={tantsorShkoli} bordered={false} pagination={false} showHeader={false} style={{ paddingBottom: "15px" }} locale={{ emptyText: <Empty description={""}></Empty> }} size="small" rowKey={(r) => r.ID} />
                        </div>}
                    </div>
                    <div>
                        <div style={{ display: "flex", justifyContent: "space-between", marginBottom: "10px", marginTop: "25px", paddingRight: "10px" }}>
                            <div style={{
                                fontFamily: "-apple-system, BlinkMacSystemFont, Roboto, 'Open Sans', 'Helvetica Neue', 'Noto Sans Armenian', 'Noto Sans Bengali', 'Noto Sans Cherokee', 'Noto Sans Devanagari', 'Noto Sans Ethiopic', 'Noto Sans Georgian', 'Noto Sans Hebrew', 'Noto Sans Kannada', 'Noto Sans Khmer', 'Noto Sans Lao', 'Noto Sans Osmanya', 'Noto Sans Tamil', 'Noto Sans Telugu', 'Noto Sans Thai', sans-serif",
                                fontSize: "13px",
                                fontWeight: "600",
                                color: "rgb(0, 0, 0)",
                            }}>
                                Преподаватель школы
                            </div>
                            <div style={{ flex: "auto", margin: "10px 10px", height: "1px", backgroundColor: "#f0f0f0" }}></div>
                        </div>
                        {(prepodavatelShkoli && prepodavatelShkoli.length <= 0) && <div className={classes.actionTitle}>
                            Не являюсь преподавателем в танцевальных школах
                        </div>}
                        {(prepodavatelShkoli && prepodavatelShkoli.length > 0) && <div>
                            <Table className={classes.table} columns={columnsPrepodavatelShkoli} dataSource={prepodavatelShkoli} bordered={false} pagination={false} showHeader={false} style={{ paddingBottom: "15px" }} locale={{ emptyText: <Empty description={""}></Empty> }} size="small" rowKey={(r) => r.ID} />
                        </div>}
                    </div>
                    <div>
                        <div style={{ display: "flex", justifyContent: "space-between", marginBottom: "10px", marginTop: "25px", paddingRight: "10px" }}>
                            <div style={{
                                fontFamily: "-apple-system, BlinkMacSystemFont, Roboto, 'Open Sans', 'Helvetica Neue', 'Noto Sans Armenian', 'Noto Sans Bengali', 'Noto Sans Cherokee', 'Noto Sans Devanagari', 'Noto Sans Ethiopic', 'Noto Sans Georgian', 'Noto Sans Hebrew', 'Noto Sans Kannada', 'Noto Sans Khmer', 'Noto Sans Lao', 'Noto Sans Osmanya', 'Noto Sans Tamil', 'Noto Sans Telugu', 'Noto Sans Thai', sans-serif",
                                fontSize: "13px",
                                fontWeight: "600",
                                color: "rgb(0, 0, 0)",
                            }}>
                                Коллективы федерации
                            </div>
                            <div style={{ flex: "auto", margin: "10px 10px", height: "1px", backgroundColor: "#f0f0f0" }}></div>
                            <DropdownAction items={[
                                IFTrue("samostoyatelnayaregistratsiyakollektivafederatsii", {
                                    ...props,
                                    mode: "MenuItem",
                                    title: "Зарегистрировать коллектив",
                                    form: SamostoyatelnayaRegistratsiyaKollektivaFederatsii,
                                    document: "samostoyatelnayaregistratsiyakollektivafederatsii"
                                }, undefined, ctx),
                                ExtendedPropertiesAction(auth, 'для всех объектов "Коллективы федерации"',
                                    {
                                        kollektivID: null,
                                        tipPolzovatelyaID: 20,
                                        polzovatelID: user?.ID
                                    },
                                    [
                                        MDXField("Общее описание", "", "ОбщееОписание", false, false),
                                        MDXField("Дополнительная информация", "", "ДополнительнаяИнформация", false, false),
                                    ],
                                    "MenuItem"
                                ),
                            ]} />
                        </div>
                        <Rule type={"samostoyatelnayaregistratsiyakollektivafederatsii"}>
                            <div className={classes.actionTitle}>
                                Нет коллективов
                            </div>
                        </Rule>
                        <Rule type={"not-samostoyatelnayaregistratsiyakollektivafederatsii"}>
                            <Table className={classes.table} columns={columnsKollektiv} dataSource={kollektiv} bordered={false} pagination={false} showHeader={true} style={{ paddingBottom: "15px" }} locale={{ emptyText: <Empty description={""}></Empty> }} size="small" rowKey={(r) => r.ID} />
                        </Rule>
                    </div>
                    <div>
                        <div style={{ display: "flex", justifyContent: "space-between", marginBottom: "10px", marginTop: "25px", paddingRight: "10px" }}>
                            <div style={{
                                fontFamily: "-apple-system, BlinkMacSystemFont, Roboto, 'Open Sans', 'Helvetica Neue', 'Noto Sans Armenian', 'Noto Sans Bengali', 'Noto Sans Cherokee', 'Noto Sans Devanagari', 'Noto Sans Ethiopic', 'Noto Sans Georgian', 'Noto Sans Hebrew', 'Noto Sans Kannada', 'Noto Sans Khmer', 'Noto Sans Lao', 'Noto Sans Osmanya', 'Noto Sans Tamil', 'Noto Sans Telugu', 'Noto Sans Thai', sans-serif",
                                fontSize: "13px",
                                fontWeight: "600",
                                color: "rgb(0, 0, 0)",
                            }}>
                                Пары федерации
                            </div>
                            <div style={{ flex: "auto", margin: "10px 10px", height: "1px", backgroundColor: "#f0f0f0" }}></div>
                            <DropdownAction items={[
                                {
                                    ...props,
                                    mode: "MenuItem",
                                    callback: update_pari,
                                    title: "Зарегистрировать пару",
                                    form: PredlozhenieRukiISerdtsa,
                                    document: "predlozhenierukiiserdtsa"
                                },
                                ExtendedPropertiesAction(auth, 'для всех объектов "Пары федерации"',
                                    {
                                        paraID: null,
                                        tipPolzovatelyaID: 17,
                                        polzovatelID: user?.ID
                                    },
                                    [
                                        MDXField("Общее описание", "", "ОбщееОписание", false, false),
                                        MDXField("Дополнительная информация", "", "ДополнительнаяИнформация", false, false),
                                    ],
                                    "MenuItem"
                                ),
                            ]} />
                        </div>
                        <Rule type={"predlozhenierukiiserdtsa"}>
                            <div className={classes.actionTitle}>
                                Нет пары
                            </div>
                        </Rule>
                        <Rule type={"pari"}>
                            <Table className={classes.table} columns={columnsPari} dataSource={pari} bordered={false} pagination={false} showHeader={false} style={{ paddingBottom: "15px" }} locale={{ emptyText: <Empty description={""}></Empty> }} size="small" rowKey={(r) => r.ID} />
                        </Rule>
                    </div>
                    <div>
                        <div style={{ display: "flex", justifyContent: "space-between", marginBottom: "10px", marginTop: "25px", paddingRight: "10px" }}>
                            <div style={{
                                fontFamily: "-apple-system, BlinkMacSystemFont, Roboto, 'Open Sans', 'Helvetica Neue', 'Noto Sans Armenian', 'Noto Sans Bengali', 'Noto Sans Cherokee', 'Noto Sans Devanagari', 'Noto Sans Ethiopic', 'Noto Sans Georgian', 'Noto Sans Hebrew', 'Noto Sans Kannada', 'Noto Sans Khmer', 'Noto Sans Lao', 'Noto Sans Osmanya', 'Noto Sans Tamil', 'Noto Sans Telugu', 'Noto Sans Thai', sans-serif",
                                fontSize: "13px",
                                fontWeight: "600",
                                color: "rgb(0, 0, 0)",
                            }}>
                                Член федерации
                            </div>
                            <div style={{ flex: "auto", margin: "10px 10px", height: "1px", backgroundColor: "#f0f0f0" }}></div>
                            <DropdownAction items={[
                                IFTrue("zayavlenienachlenstvovfederatsii", {
                                    ...props,
                                    mode: "MenuItem",
                                    title: "Стать членом Федерации",
                                    form: ZayavlenieNaChlenstvoVFederatsii,
                                    document: "zayavlenienachlenstvovfederatsii"
                                }, undefined, ctx),
                                IFTrue("samostoyatelnayaregistratsiyavikhodaizchlenstvavfederatsii", {
                                    ...props,
                                    mode: "MenuItem",
                                    title: "Выйти из Федерации",
                                    form: SamostoyatelnayaRegistratsiyaVikhodaIzChlenstvaVFederatsii,
                                    document: "samostoyatelnayaregistratsiyavikhodaizchlenstvavfederatsii"
                                }, undefined, ctx),
                                ExtendedPropertiesAction(auth, 'для всех объектов "Член федерации"',
                                    {
                                        // tantsorID: 12
                                        tipPolzovatelyaID: 10,
                                        polzovatelID: user?.ID
                                    },
                                    [
                                        MDXField("Общее описание", "", "ОбщееОписание", false, false),
                                        MDXField("Дополнительная информация", "", "ДополнительнаяИнформация", false, false),
                                    ],
                                    "MenuItem"
                                ),
                            ]} />
                        </div>
                        <Rule type={"zayavlenienachlenstvovfederatsii"}>
                            <div className={classes.actionTitle}>
                                Не являюсь Членом Федерации
                            </div>
                        </Rule>
                        <Rule type={"not-zayavlenienachlenstvovfederatsii"}>
                            <Table className={classes.table} columns={columnsChlen} dataSource={chlenFederatsii} bordered={false} pagination={false} showHeader={false} style={{ paddingBottom: "15px" }} locale={{ emptyText: <Empty description={""}></Empty> }} size="small" rowKey={(r) => r.ID} />
                        </Rule>
                    </div>
                </div>
            </div>
        </PageLayout >
    );
}
